import { render, staticRenderFns } from "./CommunicationDiagram.vue?vue&type=template&id=27e38809"
import script from "./CommunicationDiagram.vue?vue&type=script&lang=js"
export * from "./CommunicationDiagram.vue?vue&type=script&lang=js"
import style0 from "./CommunicationDiagram.vue?vue&type=style&index=0&id=27e38809&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports